{
  "pageTitle": "Meter Readings",
  "pageDescription": "Take a photo of a meter, let the AI read it, review, and send it where it needs to go.",
  "action": {
    "takePhoto": "Take / Upload Photo",
    "choosePhoto": "Choose Photo from Library"
  },
  "notEnabled": {
    "title": "Meter readings are not enabled",
    "description": "Enable meter readings on an address provider under Addresses to start submitting readings.",
    "link": "Go to Addresses"
  },
  "review": {
    "title": "Review Reading",
    "readingValue": "Reading",
    "secondaryReadingValue": "Second reading",
    "meterNumber": "Meter number",
    "confidence": "Confidence",
    "rawText": "Raw text from meter",
    "notes": "Notes",
    "confidenceHigh": "High",
    "confidenceMedium": "Medium",
    "confidenceLow": "Low",
    "editHint": "Correct the readings if needed before continuing.",
    "confirmEmail": "Send Email",
    "confirmForm": "Submit",
    "retake": "Retake"
  },
  "settings": {
    "title": "Meter Reading Settings",
    "noAddress": "No address has meter readings enabled for this provider yet. Enable it under Addresses.",
    "linkHint": "Readings are submitted for the address where you enabled meter readings for this provider under Addresses. Fill in the details sent with each submission — they can differ per provider.",
    "reportName": "Name",
    "reportAddress": "Address",
    "reportCustomerCode": "Customer code",
    "reportPhone": "Phone number",
    "reportEmail": "Report email",
    "reportCc": "Report CC",
    "save": "Save Settings",
    "saved": "Settings saved",
    "saveError": "Failed to save settings",
    "loadError": "Failed to load settings",
    "loadProvidersError": "Failed to load meter providers",
    "missingWarning": "Fill in the report details below before submitting a meter reading.",
    "missingRequired": "Please fill in all report details."
  },
  "history": {
    "title": "Recent Readings",
    "empty": "No readings yet",
    "emptyHint": "Upload a photo or enter a reading manually to start the history.",
    "statusExtracted": "Extracted",
    "statusEmailed": "Emailed",
    "statusSubmitted": "Submitted",
    "statusFailed": "Failed"
  },
  "extracting": "Reading meter...",
  "processing": "Processing...",
  "photoAlt": "Meter photo",
  "photoLibraryPermissionDenied": "Photo library permission is required to choose an existing photo.",
  "successEmail": "Email sent successfully.",
  "successForm": "Reading submitted successfully.",
  "extractError": "Failed to read the meter. Try a clearer photo.",
  "confirmError": "Failed to send the reading.",
  "photoTooLarge": "Photo is too large. Maximum size is 5MB.",
  "invalidPhoto": "Invalid photo format.",
  "uploadHint": "JPEG, PNG, WebP or HEIC, up to 5MB"
}
